import React from 'react';
import {NextStep, NextStepProvider} from 'nextstepjs';
import {OnboardingCard} from 'modules/onboarding/widgets/OnboardingCard';
import {useGetSteps} from 'modules/onboarding/hooks';

interface IOnboardingProviderProps {
    children: React.ReactNode;
}

export const OnboardingProvider = (props: IOnboardingProviderProps) => {
    const {children} = props;
    const steps = useGetSteps();

    return (
        <NextStepProvider>
            <NextStep steps={steps} cardComponent={OnboardingCard} shadowRgb={'20, 22, 26'} shadowOpacity={'0.35'}>
                {children}
            </NextStep>
        </NextStepProvider>
    );
};
